export const mcpEnUS = {
  pageTitle: "AI Connections",
  back: "Back",
  cardDescription: "Let your team use their AI tools with your Invup data.",
  statusEnabled: "Enabled",
  statusOff: "Turned off",
  statusTurningOn: "Turning on…",
  statusPro: "Available on Pro",
  statusUnavailable: "Temporarily unavailable",
  statusLoadFailed: "Status unavailable",
  countNone: "No connections yet",
  count_one: "1 connection",
  count_other: "{{count, number}} connections",
  countPaused_one: "1 connection paused",
  countPaused_other: "{{count, number}} connections paused",
  connectionsLabel: "Connections",
  countPausedValue_one: "1 paused",
  countPausedValue_other: "{{count, number}} paused",
  hintEnabled: "Counted across your whole organization.",
  hintNone:
    "No one has connected an AI tool yet. Members connect from their own profile.",
  hintOffManager:
    "Members see their connections as disabled by your organization. Turn this back on to restore them.",
  hintOffViewer:
    "Members see their connections as disabled by your organization. Ask someone who manages integrations to turn this back on.",
  switchLabel: "Allow AI connections",
  switchDescription:
    "When off, AI tools can't reach your organization's data. Connections are paused, not deleted.",
  readOnlyNote: "Only people who manage integrations can change this setting.",
  turnedOffSuccess: "AI connections turned off successfully.",
  turnedOnSuccess:
    "AI connections turned on successfully. Existing connections work again.",
  turnOnError:
    "Sorry, AI connections could not be turned on due to an error on our end. Please try again.",
  turnOffError:
    "Sorry, AI connections could not be turned off due to an error on our end. Please try again.",
  forbiddenError:
    "You no longer have permission to change this setting. Reload the page to see your current access.",
  loadError:
    "Sorry, the AI connections status could not be loaded due to an error on our end. Please try again.",
  retry: "Try Again",
  upgradeTitle: "Connect your AI tools to Invup",
  upgradeBody:
    "Let members use any AI tool that supports MCP, such as Claude, ChatGPT or Cursor, with your organization's data. Available on the Pro plan.",
  upgradeAskOwner: "Ask your organization owner about upgrading.",
  upgradeCta: "Upgrade to Pro",
  unavailableTitle: "AI connections are temporarily unavailable",
  unavailableBody:
    "Invup has paused AI connections for every organization. Your setting and your members' connections are kept, and they will work again once the service is back.",
  overviewText:
    "AI connections let members use any AI tool that supports MCP, such as Claude, ChatGPT or Cursor, with your Invup data. Each connection acts with its member's role, so an AI tool can only see and do what that member can.",
  feature1Prefix: "Each member connects their AI tool from their own",
  profileLink: "profile",
  feature1Suffix: "and approves access once.",
  feature2: "A connection can only see and do what its member's role allows.",
  feature3:
    "Turning connections off pauses every connection at once. Turning them back on restores them, and nobody needs to approve again.",
  turnOffTitle: "Turn Off AI Connections",
  turnOffBody_one:
    "1 connection will stop working right away, and its member will see it as disabled by your organization. Nothing is deleted: turn connections back on and it works again without anyone approving it.",
  turnOffBody_other:
    "{{count, number}} connections will stop working right away, and members will see them as disabled by your organization. Nothing is deleted: turn connections back on and they work again without anyone approving them.",
  turnOffBodyNone:
    "No one has connected an AI tool yet. While this is off, members can't connect AI tools to your organization. You can turn it back on at any time.",
  turnOffConfirm: "Turn Off",
};
